module.exports = __webpack_require__.p + "e3aad78e82a8d1f939159646711bcaf7.png";